import * as constants from '../constants';

/**
 * Function to validate email
 * @param {string} value
 */
export const EmailValidate = email => constants.emailRejex.test(email);
